import { Button, Flex, Stack, useSteps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import ScheduleMeetingForm from "./Form/ScheduleMeetingForm";
import SelectMeetingForm from "./Form/SelectMeetingForm";
import { useScheduleMeeting } from "../hooks";

interface ScheduleOrSelectMeetingStepsProps {
  meetingId: string;
  onClose: () => void;
}

interface ScheduleOrSelectMeetingFormWrapperProps extends PropsWithChildren {
  onClick: () => void;
  buttonText?: string;
}

function ScheduleOrSelectMeetingFormWrapper({ children, onClick, buttonText = "Close" }: ScheduleOrSelectMeetingFormWrapperProps) {
  return (
    <Stack mt="4">
      {children}
      <Flex w="100%" justify="flex-end">
        <Button onClick={onClick}>{buttonText}</Button>
      </Flex>
    </Stack>
  );
}

export default function ScheduleOrSelectMeetingSteps({ meetingId, onClose }: ScheduleOrSelectMeetingStepsProps) {
  const { activeStep, goToNext } = useSteps({
    index: 0,
    count: 2,
  });
  const { mutate: onScheduleMeeting, isPending: isScheduling } = useScheduleMeeting(meetingId);
  const renderStepContent = (stepNumber: number) => {
    switch (stepNumber) {
      case 0:
        return (
          <ScheduleOrSelectMeetingFormWrapper onClick={onClose} buttonText="Close">
            <SelectMeetingForm meetingId={meetingId} onClickScheduleSession={() => goToNext()} />
          </ScheduleOrSelectMeetingFormWrapper>
        );
      case 1:
        return (
          <ScheduleMeetingForm
            onComplete={onClose}
            onSubmit={(params) => onScheduleMeeting(params, { onSuccess: onClose })}
            submitIsLoading={isScheduling}
            meetingId={meetingId}
          />
        );
      default:
        return null;
    }
  };

  return renderStepContent(activeStep);
}
